import { ltiPages } from "pages/lti";
import { matchPath } from "react-router-dom";

export const isLtiPage = (pathname: string): boolean =>
  ltiPages.some(({ path }) =>
    matchPath(
      {
        path,
      },
      pathname,
    ),
  );
